import type { Topic } from "../../../types/content";

import { TopicTeaser } from "../../Teaser/TopicTeaser";
import { SearchError } from "../../Discover/SearchError";

export function TopicsSearchList({
  topics,
  searchQuery,
}: {
  topics: Array<Topic>;
  searchQuery: string;
}) {
  if (!topics || topics.length === 0) {
    return (
      <SearchError
        title="Vi hittade inga ämnen"
        text={`Vi verkar sakna ämnen som matchar din sökning på "${searchQuery}"…`}
      />
    );
  }

  return (
    <>
      {topics.map((topic) => (
        <TopicTeaser key={`topic-${topic.topic_id}`} topic={topic} />
      ))}
    </>
  );
}
